export const commonSettings = {
    dataServer: "https://app.cospar-assembly.org/api",
    //dataServer: "/api",
    webServer: "https://app.cospar-assembly.org",
    graphqlServer: "https://app.cospar-assembly.org/graphql",
    matrixServer: "https://app.cospar-assembly.org",
    matrixServerName: "cospar"
};
